import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "./messages";
import Topics from "./topics";
import Logger from './logger';

let BrowserHistory = window.history;
if(!('pushState' in window.history)) {
    BrowserHistory = {
        pushState: () => { /* stub this for old browsers */ },
        back: () => { /* stub this for old browsers */ }
    };
}

// In order to know, what state is popped on "popstate" event, we have to keep
// track of the internal state of on-site history events.
// e.g.
//
// push('search') => internalHistoryState = ['search']
// push('menu') => internalHistoryState = ['search', 'menu']
//
// We cannot track the history-state with `pushState` since the current state
// is deleted when popstate is triggered
let internalHistoryState = [];

// These flags are for tracking circular removals of history states while pressing back in your browser and vise versa
let noHistoryBack = false;

// To sync the async behaviour of history.back a command and event queue is introduced
const commandQueue = [];
const eventQueue = [];

// For debugging purposes
let nextCommandId = 1;

function push(token) {
    queueCommand({
        command: 'push',
        token,
        url: token ? `#${token}` : ''
    });
    processCommandQueue();
}

function pushURL(url, token) {
    queueCommand({
        command: 'push',
        token,
        url: token ? `${url}#${token}` : url
    });
    processCommandQueue();
}

function remove(tokenToBeRemoved) {
    queueCommand({
        command: 'remove',
        token: tokenToBeRemoved
    });
    processCommandQueue();
}

MessageBroker.subscribe(Messages.HISTORY.BACK, () => {
    if(noHistoryBack) {
        queueEvent('back');
        processCommandQueue();
        return;
    }
    queueCommand({
        command: 'pop'
    });
    processCommandQueue();
});

export default {
    push,
    pushURL,
    remove
};

function processCommandQueue() {
    // This timeout is necessary for firefox
    // Firefox will "kill" the current JavaScript routine when calling history.back()
    // So we postpone processing into the next tick
    setTimeout(() => {
        while (commandQueue.length) {
            const current = commandQueue[0];
            const waitFor = current.waitFor;
            const currentEvent = eventQueue[0];
            if (waitFor) {
                if (waitFor !== currentEvent) {
                    break;
                }
                eventQueue.shift();
            }
            Logger.debug('[PROCESS] ', current.id, current.command);
            if (current.command === 'push') {
                const token = current.token;
                const url = current.url;
                internalHistoryState.push(token);
                BrowserHistory.pushState({token}, '', url);
            } else if (current.command === 'back') {
                BrowserHistory.back();
            } else if (current.command === 'disable') {
                noHistoryBack = true;
            } else if (current.command === 'enable') {
                noHistoryBack = false;
            } else if (current.command === 'pop') {
                const token = internalHistoryState.pop();
                if (token) {
                    MessageBroker.publish(`${Topics.HISTORY}.${token}`);
                }
            } else if (current.command === 'remove') {
                const tokenToBeRemoved = current.token;
                const beforeLength = internalHistoryState.length;
                internalHistoryState = internalHistoryState.filter((token) => {
                    return token !== tokenToBeRemoved;
                });
                const afterLength = internalHistoryState.length;
                queueCommand({
                    command: 'disable',
                });

                for (let i = 0; i < beforeLength - afterLength; i++) {
                    queueCommand({
                        command: 'back'
                    });
                    queueCommand({
                        command: 'noop',
                        waitFor: 'back'
                    });
                }

                queueCommand({
                    command: 'enable',
                });

            }
            commandQueue.shift();
        }
    });
}

function queueEvent(event) {
    Logger.debug('[HISTORY] addEvent', event);
    eventQueue.push(event);
}

function queueCommand(commandObject) {
    commandObject.id = nextCommandId;
    nextCommandId++;
    Logger.debug(`[HISTORY] ${commandObject.command}`, commandObject);
    commandQueue.push(commandObject);
}
